module.exports = __webpack_public_path__ + "img/footer-top.86e83072f44a99a266ff5a22bed946b9.svg";